function init_articles() {
    init_tree_article('Documents');
}

function init_tree_article(source) {

    wait.start();

    var params = {
        'source': source
    };

    $.ajax({
        type: "GET",
        url: "/articles/tree/",
        data: params,
        dataType: 'json',
        success: function (response) {

            var treeDataSource = new DataSourceTree({data: response});

            $('#tree1').ace_tree({
                dataSource: treeDataSource,
                multiSelect: false,
                loadingHTML: '<div class="tree-loading"><i class="ace-icon fa fa-refresh fa-spin blue"></i></div>',
                'open-icon': 'ace-icon tree-minus',
                'close-icon': 'ace-icon tree-plus',
                'selectable': true,
                'selected-icon': 'ace-icon fa fa-check',
                'unselected-icon': 'ace-icon fa fa-check'
            });

            $('#tree1').on('closed', function (evt, data) {

                $('#tree1').find(".tree-item").removeClass('tree-selected');

            });

            $('#tree1').on('click', function (evt, data) {

                $('#article_content').html('');

            });

            $('#tree1').on('selected', function (evt, data) {


                load_article(data, source);
            });

            wait.stop();

        }

    });

}

function load_article(data, source) {

    var params = {
        'my_item': data,
        'source': source
    };

    $.ajax({
        type: "POST",
        url: "/articles/charger/",
        data: params,
        dataType: 'html',
        success: function (response) {

            $('#article_content').html(response);

        }

    });

}
